import emailjs from "@emailjs/browser";

// EmailJS is a third-party templating service. The public key is intentionally
// shipped client-side (this is how EmailJS works); rotate it via the EmailJS
// dashboard if needed. Both templates are also used by the iOS app - keep the
// `template_params` schemas in sync with `Lulu/Handlers/EmailProvider.swift`.
const EMAILJS_SERVICE_ID = "service_8gupy1p";
const EMAILJS_PUBLIC_KEY = "jWBhaWeLwtPyqALO6";
const CONTACT_TEMPLATE_ID = "template_i1hm5qn";
const REGISTRATION_TEMPLATE_ID = "template_1bsiosm";

// Back-compat: existing callers (legacy onboarding) used this name and the
// contact template. Keep the export so they keep working.
export const sendEmail = async (emailData) => {
  await emailjs.send(
    EMAILJS_SERVICE_ID,
    CONTACT_TEMPLATE_ID,
    emailData,
    { publicKey: EMAILJS_PUBLIC_KEY }
  );
};

// Contact form (Feedback / Support). Mirrors iOS `EmailProvider.send(emailInfo:)`.
// Required template_params: name, email, title, message, group.
export const sendContactMessage = async ({
  name,
  email,
  title,
  message,
  group = "default",
}) => {
  await emailjs.send(
    EMAILJS_SERVICE_ID,
    CONTACT_TEMPLATE_ID,
    { name, email, title, message, group },
    { publicKey: EMAILJS_PUBLIC_KEY }
  );
};

// New-employee credentials email. Mirrors iOS `EmailProvider.send(registrationEmail:)`.
// Required template_params: businessName, recipientName, recipientEmail, password, group.
// The password transits EmailJS (inherited from iOS). Never log it.
export const sendEmployeeCredentials = async ({
  businessName,
  recipientName,
  recipientEmail,
  password,
  group = "default",
}) => {
  await emailjs.send(
    EMAILJS_SERVICE_ID,
    REGISTRATION_TEMPLATE_ID,
    { businessName, recipientName, recipientEmail, password, group },
    { publicKey: EMAILJS_PUBLIC_KEY }
  );
};
